module.exports = __webpack_public_path__ + "img/favicon.cd5d4aa2.png";